// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"4fa7ee0c","404":"ac468c30","440":"7523db1e"}[chunkId] + ".chunk.css";
};